import { TranslationMessages } from '../types';
import { app } from './app/no';
import { settingsApp } from './app/no';

const no: TranslationMessages = {
  nav: {
    howItWorks: 'Slik fungerer det',
    why: 'Hvorfor?',
    features: 'Funksjoner',
    getStarted: 'KOM I GANG',
    dashboard: 'Dashboard',
    blog: 'Blogg',
  },
  hero: {
    title1: 'Telegram Stars',
    title2: 'Få betalt enkelt',
    subtitle: 'Opprett betalingslenker umiddelbart, administrer saldoen din og ta ut til TON. 3 % plattformgebyr.',
    cta: 'Kom i gang',
    hairsim: 'Simuler hårtransplantasjonen din',
  },
  demo: {
    botName: 'Telegram Stars Bot',
    online: 'online',
    linkCreated: 'Betalingslenke opprettet.',
    invoiceTitle: 'Premium Access',
    invoiceDesc: 'Månedlig abonnement',
    stars: 'Stars',
    payBtn: 'Betal 100 Stars',
    iPayNow: 'Jeg betaler nå',
    paymentLabel: 'Telegram Stars-betaling',
    merchant: 'Selger',
    amount: 'Beløp',
    confirmPay: 'Bekreft betaling',
    paymentReceived: 'Betaling mottatt — 100 Stars',
    invoiceCredited: 'Invoice #xk9m2 · kreditert til saldo',
    thanks: 'Takk, tilgang aktivert',
    messagePlaceholder: 'Melding',
  },
  stats: {
    title: 'Betrodd av tusenvis av agenter',
    subtitle: 'Bli med i et voksende fellesskap av selgere som bruker Telegram Stars-betalinger',
    activeAgents: 'Aktive agenter',
    transactions: 'Transaksjoner',
    uptime: 'Oppetid',
    support: 'Support',
  },
  features: {
    title: 'Alt du trenger for å akseptere Telegram Stars-betalinger',
    subtitle: 'En komplett plattform for å administrere Telegram Stars-betalingene dine',
    instantTitle: 'Umiddelbar opprettelse',
    instantDesc: 'Bli agent på sekunder. Ingen konfigurasjon kreves.',
    balanceTitle: 'Saldo administrasjon',
    balanceDesc: 'Følg inntektene dine i sanntid med et intuitivt dashboard.',
    paymentsTitle: 'Telegram Stars-betalinger',
    paymentsDesc: 'Aksepter betalinger i Telegram Stars via boten din.',
    securityTitle: 'Maksimal sikkerhet',
    securityDesc: 'Uforanderlig ledger, sikre og transparente transaksjoner.',
    withdrawTitle: 'TON-uttak',
    withdrawDesc: 'Ta ut midlene dine direkte til TON-adressen din.',
    apiTitle: 'Robust API',
    apiDesc: 'Enkel integrasjon med webhooks og et komplett REST API.',
  },
  how: {
    title: 'Slik fungerer det',
    subtitle: 'Kom i gang i 3 enkle trinn',
    startDemo: 'Start demo',
    demoRunning: 'Demo kjører...',
    reset: 'Tilbakestill',
    step1Title: '1. Registrer deg',
    email: 'E-post',
    password: 'Passord',
    noCard: '✓ Ingen kredittkort kreves',
    step2Title: '2. Opprett betalingslenker',
    amountStars: 'Beløp (Stars)',
    generatedLink: 'Generert lenke:',
    shareLink: '✓ Del denne lenken med kundene dine',
    step3Title: '3. Ta ut midlene dine',
    tonAddress: 'TON-adresse',
    availableBalance: 'Tilgjengelig saldo:',
    fee: 'Gebyr: 3 %',
  },
  pricing: {
    title: 'Enkle og transparente priser',
    subtitle: 'Ingen skjulte gebyrer, ingen binding',
    commission: 'Provisjon',
    perTransaction: 'per transaksjon',
    freeAccount: 'Gratis kontoopprettelse',
    noMonthly: 'Ingen månedlige gebyrer',
    tonWithdrawals: 'Integrerte TON-uttak',
    completeDashboard: 'Komplett dashboard',
    support247: 'Support døgnet rundt',
    startNow: 'Start nå',
  },
  faq: {
    title: 'Ofte stilte spørsmål',
    subtitle: 'Alt du trenger å vite om Telegram Stars-betalinger',
    q1: 'Hvordan fungerer Telegram Stars-betaling?',
    a1: 'Telegram Stars-betaling lar selgere akseptere betalinger direkte via Telegram. Brukere oppretter betalingslenker, deler dem med kunder og mottar betalinger i Telegram Stars-valutaen.',
    q2: 'Hva er plattformgebyret?',
    a2: 'Plattformgebyret er 3 % per transaksjon. Dette dekker betalingsbehandling, ledger-administrasjon og plattformvedlikehold. Det er ingen oppsettgebyrer eller månedlige kostnader.',
    q3: 'Hvordan tar jeg ut Telegram Stars?',
    a3: 'Du kan be om uttak til TON-lommeboken din. Uttak behandles manuelt av sikkerhetsgrunner. Minimum uttak er 100 Stars.',
    q4: 'Er Telegram Stars-betaling sikker?',
    a4: 'Ja, alle betalinger behandles via Telegrams sikre betalingssystem. Vi bruker bransjestandard kryptering og sikkerhetspraksis.',
    q5: 'Hva er Telegram Stars?',
    a5: 'Telegram Stars er en virtuell valuta brukt i Telegram for betalinger. Brukere kan kjøpe Stars og bruke dem til å betale for tjenester, produkter og abonnementer.',
    q6: 'Kan jeg bruke Telegram Stars-betalinger for bedriften min?',
    a6: 'Ja! Telegram Stars Payment Platform er designet for selgere, skapere og bedrifter. Du kan akseptere betalinger for digitale produkter, tjenester, abonnementer og mer.',
  },
  cta: {
    title: 'Klar til å komme i gang?',
    subtitle: 'Bli med tusenvis av agenter som allerede bruker plattformen vår',
    createAccount: 'Opprett gratis konto',
    signIn: 'Logg inn',
  },
  footer: {
    description: 'Komplett SaaS-plattform for Telegram Stars-betalinger',
    product: 'Produkt',
    features: 'Funksjoner',
    pricing: 'Priser',
    support: 'Support',
    signIn: 'Logg inn',
    docs: 'Dokumentasjon',
    copyright: '© 2024 Telegram Stars Payment Platform. Alle rettigheter reservert.',
  },
  seo: {
    title: 'Telegram Stars Payment Platform | Aksepter betalinger via Telegram Stars',
    description: 'Aksepter betalinger via Telegram Stars. Opprett betalingslenker umiddelbart, administrer saldoen din og ta ut til TON. 3 % plattformgebyr. Begynn å akseptere Telegram Stars-betalinger i dag.',
    keywords: 'telegram stars betaling, aksepter telegram stars, telegram stars payment platform, telegram stars betalingsgateway',
  },
  whyPage: {
    seoTitle: 'Hvorfor velge Telegram Stars Payment Platform | Fordeler',
    seoDescription: 'Oppdag hvorfor selgere og skapere velger Telegram Stars Payment Platform: umiddelbar oppsett, transparente priser, sikre betalinger og global rekkevidde.',
    title: 'Hvorfor velge oss?',
    subtitle: 'Bygget for selgere og skapere som ønsker enkle Telegram Stars-betalinger',
    r1Title: 'Umiddelbar oppsett',
    r1Desc: 'Kom i gang på sekunder. Ingen kompleks konfigurasjon eller teknisk kunnskap kreves.',
    r2Title: 'Transparente priser',
    r2Desc: 'Bare 3 % per transaksjon. Ingen skjulte gebyrer, ingen månedlige kostnader, ingen oppsettgebyrer.',
    r3Title: 'Sikker og pålitelig',
    r3Desc: 'Bygget på Telegrams sikre betalingsinfrastruktur med bransjestandard kryptering.',
    r4Title: 'Global rekkevidde',
    r4Desc: 'Aksepter betalinger fra Telegram-brukere over hele verden. Ingen geografiske begrensninger.',
    r5Title: 'Enkel integrasjon',
    r5Desc: 'Enkel API og webhooks. Integrer med eksisterende systemer på minutter.',
    r6Title: 'TON-uttak',
    r6Desc: 'Ta ut direkte til TON-lommeboken din. Raske og sikre uttak.',
  },
  howPage: {
    seoTitle: 'Slik fungerer det | Telegram Stars Payment Platform',
    seoDescription: 'Lær hvordan du aksepterer betalinger via Telegram Stars i 3 enkle trinn. Opprett kontoen din, generer betalingslenker og ta ut til TON.',
    title: 'Slik fungerer det',
    subtitle: 'Aksepter Telegram Stars-betalinger i tre enkle trinn',
  },
  settings: {
    title: "Innstillinger",
    languageSection: "Språk",
    defaultLanguage: "Standardspråk",
    languageHint: "Dette språket gjelder for hele plattformen (landingssider og grensesnitt).",
    languageSaved: "Språk oppdatert",
    ...settingsApp,
  },
  app,
};

export default no;
